// extracted by mini-css-extract-plugin
module.exports = {"homeOverviewSection":"c_f","homeOverview":"c_g","overviewParagraph":"c_h"};